import { ethers } from "ethers";

export const getContract =  (abi, address, library) => {
  try{
    return new ethers.Contract(address, abi, library)
  }
  catch(err){
    return false;
  }
}



export const formatPrice = (num) => {
  console.log(num);
  //return parseFloat(num.toFixed(decimals)).toLocaleString();
  return new Intl.NumberFormat('en-US' , { maximumSignificantDigits: 10 }).format(num);
}


